import { AbstractControl, ValidatorFn } from '@angular/forms';

export function OnlyWhitespaceValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null =>
        control.value && typeof (control.value) === 'string' && control.value.trim() === '' ?
            { onlyWhitespace: true } : null;
}
